import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent, createRef } from 'react';
import PT from 'prop-types';
import styled from 'styled-components';
import { Transition } from 'react-transition-group';
import { I as Icon } from '../Icon/Icon-1e11d9f1.js';
import { j as caretDown, k as caretInlineEnd } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-889a4ef1-7553986d.js';
import { a as TaktIdProvider } from '../TaktIdContext/TaktIdContext-f853b17a.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-39f30e88.js';
import { T as Text } from '../Text/Text-f48a0c0d.js';

const ExpanderWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30051113__sc-lcv7v-0"
})(["width:100%;"]);
ExpanderWrapper.displayName = 'ExpanderWrapper';
const ExpanderTab = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30051113__sc-lcv7v-1"
})(["cursor:pointer;border:none;background:none;padding:", ";padding-left:0;width:100%;> h3{margin:0;margin-inline-start:", ";display:inline-block;}"], ({
  theme
}) => theme.spacing.mini, ({
  theme
}) => theme.spacing.small);
ExpanderTab.displayName = 'ExpanderTab';
const ExpanderContent = /*#__PURE__*/styled.section.withConfig({
  componentId: "sc-storm-ui-30051113__sc-lcv7v-2"
})(["border-top:1px solid ", ";padding-top:", ";padding-inline-start:", ";overflow-y:hidden;max-height:0;@media (prefers-reduced-motion:no-preference){transition:", ";}", ""], ({
  theme
}) => theme.palette.alto, ({
  theme
}) => theme.spacing.base, ({
  theme
}) => theme.spacing.base, ({
  $transition
}) => $transition, ({
  $transitionState
}) => ({
  entering: 'height: 0',
  entered: 'max-height: 100vh'
})[$transitionState]);
ExpanderContent.displayName = 'ExpanderContent';
class Expander extends PureComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "containerRef", /*#__PURE__*/createRef());
    _defineProperty(this, "handleClick", () => {
      this.setState(prevState => ({
        isOpen: !prevState.isOpen
      }));
    });
    _defineProperty(this, "renderIcon", () => this.state.isOpen ? /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(Icon, {
      type: caretDown
    })) : /*#__PURE__*/React__default.createElement(Icon, {
      type: caretInlineEnd
    }));
    this.state = {
      isOpen: props.defaultOpen
    };
  }
  render() {
    const {
      children,
      label,
      transition,
      transitionDuration = 0,
      taktId,
      taktValue,
      ...rest
    } = this.props;
    const {
      isOpen
    } = this.state;
    return /*#__PURE__*/React__default.createElement(TaktIdProvider, {
      taktId: taktId,
      taktValue: taktValue,
      fallbackId: createStormTaktId('expander')
    }, /*#__PURE__*/React__default.createElement(ExpanderWrapper, rest, /*#__PURE__*/React__default.createElement(ExpanderTab, {
      onClick: this.handleClick
    }, this.renderIcon(), /*#__PURE__*/React__default.createElement(Text, {
      type: "h3"
    }, label)), /*#__PURE__*/React__default.createElement(Transition, {
      timeout: transitionDuration,
      appear: true,
      in: isOpen,
      nodeRef: this.containerRef
    }, state => {
      if (state === 'exited') return null;
      return /*#__PURE__*/React__default.createElement(ExpanderContent, {
        $transitionState: state,
        $transition: transition,
        ref: this.containerRef
      }, children);
    })));
  }
}
_defineProperty(Expander, "propTypes", {
  children: PT.node.isRequired,
  label: PT.node.isRequired,
  defaultOpen: PT.bool,
  transition: PT.string,
  transitionDuration: PT.number
});
_defineProperty(Expander, "defaultProps", {
  defaultOpen: false,
  transition: undefined,
  transitionDuration: 0
});

export { Expander as E };
//# sourceMappingURL=Expander-7c779a21.js.map
